export default __webpack_public_path__ + "static/media/addHome1.b25e1c2a.jpg";